import styled from 'styled-components'

const DaneOrganizacyjneStyle = styled.div`
  .checkboxLabel {
    height: 24px;
  }

  .czasTrwania {
    width: 100%;
    display: grid;
    grid-template-rows: auto auto;
  }

  .czasTrwania .secondRow {
    grid-row: 2/3;
    display: grid;
    grid-template-columns: 192px 76px 192px auto 1fr;
    margin-top: 16px;
  }

  .czasTrwania .separator {
    font-size: 20px;
    text-align: center;
  }

  .czasTrwania .operator {
    font-size: 11px;
    text-align: center;
    margin: auto 16px;
  }

  .uproszczenia {
    width: 100%;
    display: grid;
  }

  .kontynuacja {
    width: 100%;
    display: grid;
    grid-template-rows: auto auto auto;
    grid-row-gap: 12px;
  }

  .polaczenie {
    width: 100%;
    display: grid;
    grid-template-rows: auto auto auto;
  }

  .textArea {
    width: 100%;
    display: grid;
    min-height: 56px;
  }
`
export default DaneOrganizacyjneStyle
